<template>
    <div class="text-top">
    <v-dialog
      v-model="show"
      width="540"
    >
      <v-card tile>
        <v-card-title>Are you sure you want to perform this action?</v-card-title>
        <v-card-subtitle>Confirming this action will cancel this user's subscription</v-card-subtitle>
        <v-card-text>
            <v-radio-group
                v-model="cancel_immediately"
                value="1"
                column
            >
                <v-radio
                    label="Automatically cancel at the end of billing cycle"
                >
                </v-radio>
                <v-radio
                    label="Cancel Immediately"
                >
                </v-radio>

            </v-radio-group>
        </v-card-text>
        <v-card-actions>
            <v-spacer/>
            <v-btn
                color="primary"
                text
                @click="cancelDialog"
            >
                Cancel
            </v-btn>

            <v-btn
                color="primary"
                text
                @click="confirmDelete"
            >
                Confirm
            </v-btn>
        </v-card-actions>
    </v-card>
    </v-dialog>
    </div>
</template>
<script>
export default {
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    data: {
      default: null,
      type: Object
    },
    title: {
      type: String,
      default: 'Are your sure ? '
    }
  },
  data () {
    return {
      cancel_immediately: 1
    }
  },
  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    cancelDialog () {
      this.$emit('close')
    },
    confirmDelete () {
      this.$log.info('confirm unsub', [this.cancel_immediately])
      this.$emit('confirmAction', this.cancel_immediately)
      this.$emit('close')
    }
  }
}
</script>
